import React, { useEffect } from "react";
import {
  deleteDocument,
  downloadKyc,
  getDocuments,
} from "../../../services/settings";
import toast from "react-hot-toast";
import { useAuth } from "../../../context/AuthContextProvider";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const KycFiles = ({ handleSuccess, handleCancel, docType }) => {
  const { globalProfile } = useAuth();
  const queryClient = useQueryClient();

  const getKycDoc = async () => {
    try {
      const res = await getDocuments();
      return res;
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  const query = useQuery({
    queryKey: ["getFiles"],
    queryFn: getKycDoc,
  });

  const retrieveKyc = async (file) => {
    try {
      const blobData = await downloadKyc(file.DocumentType);
      const contentType = blobData.type;
      const blob = new Blob([blobData], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = file?.FileName;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  const deleteFile = async (id) => {
    try {
      await deleteDocument(id);
      toast.success("File deleted successfully");
      queryClient.invalidateQueries({ queryKey: ["getFiles"] });
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  const documentType = (name) => {
    if (name === "cac") {
      return "Certificate of Business Registration from the Corporate Affairs Commission";
    }
    if (name === "payment-license") {
      return "PSSP/PCIDSS";
    }
    if (name === "identity") {
      return "Means of identification for all Ultimate Beneficial Owners";
    }
    if (name === "sla") {
      return "SLA";
    }
    if (name === "proof-of-address") {
      return "Proof of Address";
    }
    return name;
  };

  useEffect(() => {
    getKycDoc();
  }, [globalProfile]);

  const fileData = query.data?.data || [];

  return (
    <div>
      <form>
        <section>
          <div className="flex flex-col items-center">
            <div className="font-medium text-xl pt-8">
              View, Download And Delete Document
            </div>
          </div>
          <section className="md:flex justify-center pt-10">
            <section className="w-[1000px] rounded-md p-6">
              <p className="font-semibold text-lg mb-4">Files added</p>
              <div className="bg-white rounded-lg border overflow-hidden">
                <DataTable
                  value={fileData}
                  emptyMessage="No documents found."
                  className="p-datatable-sm"
                  responsiveLayout="scroll"
                >
                  <Column
                    header="Document"
                    body={(row) => (
                      <div className="py-2">
                        <p className="font-medium text-gray-800">
                          {documentType(row?.DocumentType)}
                        </p>
                        <p className="text-sm text-gray-500">{row?.FileName}</p>
                      </div>
                    )}
                  />
                  <Column
                    header=""
                    style={{ width: "220px" }}
                    body={(row) => (
                      <div className="py-2">
                        <button
                          className="px-2 rounded-md w-[200px] h-[40px] text-primary border border-primary hover:bg-orange-50 font-medium transition-colors"
                          type="button"
                          onClick={() => retrieveKyc(row)}
                        >
                          Download
                        </button>
                      </div>
                    )}
                  />
                  <Column
                    header=""
                    style={{ width: "220px" }}
                    body={(row) => (
                      <div className="py-2">
                        <button
                          className="px-2 rounded-md w-[200px] h-[40px] text-white bg-primary hover:opacity-90 font-medium transition-opacity"
                          type="button"
                          onClick={() => deleteFile(row?.Id)}
                        >
                          Delete
                        </button>
                      </div>
                    )}
                  />
                </DataTable>
              </div>
            </section>
          </section>
        </section>
      </form>
    </div>
  );
};

export default KycFiles;
